module.exports = __webpack_public_path__ + "img/bgc.790af878.png";